/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import { SchemaService } from 'ajs/modules/core/services/schema-service/schema.service';
import type { TEnumValueLabelsHash } from 'ajs/modules/core/services/schema-service/schema.types';
import * as l10n from './log-cinematic-sub-section-ntlm.l10n';
import { TrafficLogCinematicStore } from '../../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';

import './log-cinematic-sub-section-ntlm.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component for displaying the NTLM sub-section in the Authentication section under traffic Log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-sub-section-ntlm',
    templateUrl: './log-cinematic-sub-section-ntlm.component.html',
})
export class LogCinematicSubSectionNtlmComponent {
    public readonly ntlmLog$ = this.logCinematicStore.ntlmLog$;

    public readonly l10nKeys = l10nKeys;

    /**
     * Key-Value map for 'NtlmStatus' enum values and display values.
     */
    public readonly ntlmStatusHash: TEnumValueLabelsHash;

    constructor(
        public readonly logCinematicStore: TrafficLogCinematicStore,
        l10nService: L10nService,
        schemaService: SchemaService,
    ) {
        l10nService.registerSourceBundles(dictionary);
        this.ntlmStatusHash = schemaService.getEnumValueLabelsHash('NtlmStatus');
    }
}
